import QRCode from 'qrcode';
import React, {useEffect, useState} from 'react';

interface QrCodeProps {
    fullUrl: string;
    size?: number;
    className?: string;
}

function QrCode({fullUrl, size, className}: QrCodeProps): JSX.Element {
    const [qrUrl, setQrUrl] = useState('');

    useEffect(() => {
        QRCode.toDataURL(fullUrl, {width: size, margin: 0}, (err, url) => {
            if (!err) {
                setQrUrl(url);
            }
        });
    }, [fullUrl, size]);

    return <img className={className} src={qrUrl} alt="qr code" style={{height: size, flexShrink: '0'}} />;
}

export default QrCode;
